import { Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: LucideIcon;
	label: string;
	value: string;
	actionIcon?: LucideIcon;
	onClick?: () => void;
	showDivider?: boolean;
};

export const ProfileAccountRow: FC<Props> = ({
	icon: Icon,
	label,
	value,
	actionIcon: ActionIcon,
	onClick,
	showDivider,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.6}
			px={1.6}
			py={1.2}
			onClick={onClick}
			borderBottom={
				showDivider
					? theme.colors.border.solid(theme.palette.grey[100])
					: "none"
			}
			sx={{ cursor: onClick ? "pointer" : "default" }}
		>
			<IconBox bg={theme.palette.grey[100]} size={36} shape="circle">
				<Icon size={theme.iconSize.sm} color={theme.palette.grey[500]} />
			</IconBox>
			<Stack flex={1} minWidth={0}>
				<Typography variant="caption" color={theme.palette.grey[500]}>
					{label}
				</Typography>
				<Typography variant="body2" color={theme.palette.grey[900]} noWrap>
					{value}
				</Typography>
			</Stack>
			{ActionIcon && <ActionIcon size={18} color={theme.palette.blue.main} />}
		</Stack>
	);
};
